// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Popover-components-PopoverArrow-PopoverArrow-module__arrow";
export { _1 as "arrow" }
